import angular from "angular";

import ServiceRA from "app/services/ServiceRA";
import AuthenticationService from "./AuthenticationService";
import ContractService from "./ContractService";
import FeatureService from "./FeatureService";
import toastr from "app/services/toastr";
import shajs from "app/services/sha";
import LocaleService from "app/services/LocaleService.js";

export default angular.module("services.BonusShopService", [shajs, LocaleService, toastr, ContractService, ServiceRA, AuthenticationService, FeatureService]).factory("BonusShopService",
  ["shajs", "LocaleService", "toastr", "ContractService", "$http", "$q", "$state", "$log", "$rootScope", "ServiceRA", "AuthenticationService", "FeatureService", "Utils",
    function BonusShopService(shajs, LocaleService, toastr, ContractService, $http, $q, $state, $log, $rootScope, ServiceRA, AuthenticationService) {

      function getBonusshopContracts() {
        let promise = AuthenticationService.getUser().then((userObj) => {
          return ServiceRA.all("contracts").getList({
            customerId: userObj.customerId,
            "product.code": ["MNC", "CYC"]
          });
        });
        return promise;
      }

      function shopLogin(card) {
        let defer = AuthenticationService.getUser().then((userObj) => {
          return ServiceRA.one("shopLogin", card.id).one(userObj._id).get({
          }, null);

        });
        return defer;
      }

      return {
        shopLogin: shopLogin,
        getBonusshopContracts: getBonusshopContracts,
      };
    }]).name;


// WEBPACK FOOTER //
// ./src/ui/modules/dcb-eaccount/services/BonusShopService.js